import ReactDOM from "react-dom/client";
import App from "./app/App";
import { Provider } from "react-redux";
import store from "./shared/redux/store";
import { getLocale } from "./shared/scripts";
import { IntlProvider } from "react-intl";
import { languages } from "./app/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const locale = getLocale();

root.render(
  <Provider store={store}>
    <IntlProvider locale={locale} messages={languages[locale]}>
      <App />
    </IntlProvider>
  </Provider>,
);
